export default {
    name: 'kendo-buttongroup-button',
    render (h) {
        return h('li',this.$slots.default)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/KendoButtonGroupButton.js